import React, { useState } from "react";

export default function RegisterUser() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobile, setMobile] = useState("");

  const Register = (e) => {
    e.preventDefault();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      userName: email,
      firstName: firstName,
      lastName: lastName,
      mobile: mobile,
      password: password,
      userType: "string",
      designation: "string",
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch("http://103.189.80.13:8089/api/auth/Register", requestOptions)
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.error(error));
    setEmail("");
    setPassword("");
    setFirstName("");
    setLastName("");
    setMobile("");
  };

  return (
    <div>
      <div>Register New User</div>

      <form onSubmit={Register}>
        <input
          className="p-2 bg-gray-200 my-2 mx-2"
          type="email"
          placeholder="enter email"
          value={email}
          required
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          className="p-2 bg-gray-200 my-2 mx-2"
          type="password"
          placeholder="enter password"
          value={password}
          required
          onChange={(e) => setPassword(e.target.value)}
        />
        <input
          className="p-2 bg-gray-200 my-2 mx-2"
          placeholder="enter first name"
          value={firstName}
          required
          onChange={(e) => setFirstName(e.target.value)}
        />
        <input
          className="p-2 bg-gray-200 my-2 mx-2"
          placeholder="enter last name"
          value={lastName}
          required
          onChange={(e) => setLastName(e.target.value)}
        />
        <input
          className="p-2 bg-gray-200 my-2 mx-2"
          placeholder="enter mobile no"
          value={mobile}
          maxLength={10}
          onChange={(e) => setMobile(e.target.value)}
        />
        <input type="submit" />
      </form>
    </div>
  );
}
